import SEO from '../components/SEO';
import './Legal.css';

const CookiePolicy = () => {
  return (
    <>
      <SEO
        title="Cookie Policy"
        description="Learn about how IdeaPetal Games uses cookies and similar tracking technologies on our website."
        keywords="cookie policy, cookies, tracking technologies"
      />
      <div className="legal-page">
        <div className="legal-header">
          <div className="container">
            <h1>Cookie Policy</h1>
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
          </div>
        </div>

        <div className="legal-content">
          <div className="container">
            <section>
              <h2>1. What Are Cookies?</h2>
              <p>
                Cookies are small text files that are placed on your computer or mobile device when you visit a website. 
                They are widely used to make websites work more efficiently and provide information to the website owners.
              </p>
            </section>

            <section>
              <h2>2. How We Use Cookies</h2>
              <p>IdeaPetal Games uses cookies for the following purposes:</p>
              
              <h3>2.1 Essential Cookies</h3>
              <p>
                These cookies are necessary for the website to function properly. They enable basic functions like page 
                navigation and access to secure areas of the website.
              </p>

              <h3>2.2 Analytics Cookies</h3>
              <p>
                We use analytics cookies to understand how visitors interact with our website. These cookies help us 
                improve our website by providing information about areas visited, time spent on pages, and any issues 
                encountered.
              </p>

              <h3>2.3 Functionality Cookies</h3>
              <p>
                These cookies allow the website to remember choices you make (such as your language preference) and 
                provide enhanced, personalized features.
              </p>

              <h3>2.4 Advertising Cookies</h3>
              <p>
                If advertising is enabled, ad partners may use cookies to measure ad performance, limit repeated ads,
                prevent invalid activity, and deliver more relevant ads.
              </p>
            </section>

            <section>
              <h2>3. Third-Party Cookies</h2>
              <p>
                In addition to our own cookies, we may also use various third-party cookies to report usage statistics 
                of the website and deliver advertisements. These third parties may include:
              </p>
              <ul>
                <li><strong>Google Analytics:</strong> To analyze website traffic and user behavior</li>
                <li><strong>Firebase Analytics:</strong> To track user engagement and app performance</li>
                <li><strong>Google AdSense:</strong> To deliver and measure ads after approval</li>
              </ul>
            </section>

            <section>
              <h2>4. Managing Cookies</h2>
              <p>
                Most web browsers allow you to control cookies through their settings preferences. However, limiting 
                cookies may impact your experience on our website. You can:
              </p>
              <ul>
                <li>Delete cookies that are already on your device</li>
                <li>Set your browser to refuse cookies</li>
                <li>Set your browser to notify you when cookies are being sent</li>
              </ul>
              <p>
                To learn more about how to manage cookies, visit{' '}
                <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">
                  www.allaboutcookies.org
                </a>.
              </p>
            </section>

            <section>
              <h2>5. Types of Cookies We Use</h2>
              <table className="cookie-table">
                <thead>
                  <tr>
                    <th>Cookie Name</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>_ga</td>
                    <td>Google Analytics - Used to distinguish users</td>
                    <td>2 years</td>
                  </tr>
                  <tr>
                    <td>_gid</td>
                    <td>Google Analytics - Used to distinguish users</td>
                    <td>24 hours</td>
                  </tr>
                  <tr>
                    <td>_gat</td>
                    <td>Google Analytics - Used to throttle request rate</td>
                    <td>1 minute</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section>
              <h2>6. Changes to This Cookie Policy</h2>
              <p>
                We may update this Cookie Policy from time to time to reflect changes in our practices or for other 
                operational, legal, or regulatory reasons. Please review this page periodically for any updates.
              </p>
            </section>

            <section>
              <h2>7. Contact Us</h2>
              <p>
                If you have any questions about our use of cookies, please contact us at{' '}
                <a href="/contact">our contact page</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;
